module.exports = __webpack_public_path__ + "img/juli-06930.a0228e32.jpeg";